import React from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import theme from "__mui-theme-src__";

export const wrapRootElement = ({ element }) =>
    <ThemeProvider theme={theme}>
        <CssBaseline />
        {element}
    </ThemeProvider>;